export default "__VITE_ASSET__q__$LP_4__"